<template>
  <v-menu
    v-model="exporting"
    :close-on-content-click="false"
    :disabled="!value[0]"
    :attach="attach"
    offset-y
  >
    <v-tooltip bottom slot="activator">
      <slot name="activator" slot="activator" @click.stop="exporting = true">
        <v-btn flat :disabled="!value[0]">
          <span>Export</span>
          <v-badge :value="!!value[0]" :color="themes.client.light.chip">
            <span slot="badge">{{ value.length }}</span>
            <v-icon medium class="red--text text--darken-3">
              mdi-file-pdf-box
            </v-icon>
          </v-badge>
        </v-btn>
      </slot>
      <span> Export {{ value.length | pluralize("application") }} to PDF </span>
    </v-tooltip>
    <v-card>
      <v-card-title>
        <div>
          <span class="subheading"> Exporting to PDF</span>
          <div class="">
            Please select sections to be included in the export.
          </div>
        </div>
      </v-card-title>
      <v-card-text>
        <v-btn
          @click="toggleSection('profile')"
          :color="themes.client.light.successButton"
          :outline="!sectionIncluded('profile')"
          block
        >
          <v-icon left v-if="sectionIncluded('profile')">mdi-check</v-icon>
          <v-icon left v-else key="profile-icon"
            >mdi-checkbox-blank-outline</v-icon
          >
          Profile
        </v-btn>

        <v-btn
          @click="toggleSection('screening_question')"
          :outline="!sectionIncluded('screening_question')"
          :color="themes.client.light.successButton"
          block
        >
          <v-icon left v-if="sectionIncluded('screening_question')"
            >mdi-check</v-icon
          >
          <v-icon left v-else key="screening_questions-icon">
            mdi-checkbox-blank-outline
          </v-icon>
          Screening Questions
        </v-btn>

        <v-btn
          @click="toggleSection('identity')"
          :color="themes.client.light.successButton"
          :outline="!sectionIncluded('identity')"
          block
        >
          <v-icon left v-if="sectionIncluded('identity')">mdi-check</v-icon>
          <v-icon left v-else key="identification-icon"
            >mdi-checkbox-blank-outline</v-icon
          >
          Proof of Identity
        </v-btn>
        <v-btn
          @click="toggleSection('transcript')"
          :color="themes.client.light.successButton"
          :outline="!sectionIncluded('transcript')"
          block
        >
          <v-icon left v-if="sectionIncluded('transcript')">mdi-check</v-icon>
          <v-icon left v-else key="transcripts-icon"
            >mdi-checkbox-blank-outline</v-icon
          >
          Academic Transcripts
        </v-btn>
        <v-btn
          v-if="needsHouseholdIncome"
          @click="toggleSection('financial')"
          :color="themes.client.light.successButton"
          :outline="!sectionIncluded('financial')"
          block
        >
          <v-icon left v-if="sectionIncluded('financial')">mdi-check</v-icon>
          <v-icon left v-else key="financial-icon"
            >mdi-checkbox-blank-outline</v-icon
          >
          Household Income
        </v-btn>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn flat @click.stop="exporting = false">Cancel</v-btn>
        <v-btn
          :color="themes.client.light.primaryActionButton"
          @click.stop="pdf"
        >
          <v-icon left>mdi-file-pdf-box</v-icon>
          Export
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { generatedDocumentDownloads } from "@/mixins/generatedDocumentDownloads.js";

export default {
  mixins: [generatedDocumentDownloads],

  props: {
    attach: { type: Boolean, default: false },
    opportunity: Object,
    profile: Object,
    value: { type: Array, default: () => [] },
  },

  data() {
    return {
      exporting: false,
      sections: [
        "profile",
        "financial",
        "screening_question",
        "identity",
        "transcript",
      ],
    };
  },

  computed: {
    needsHouseholdIncome() {
      if (this.opportunity && this.opportunity.phases) {
        for (let phase of this.opportunity.phases) {
          for (let behavior of phase.behaviors) {
            if (
              behavior.type === "OpportunityPhaseBehavior::FinancialAssessment"
            )
              return true;
          }
        }
      }
      if (this.profile && this.profile.financial) {
        return this.profile.financial.complete;
      }
      return false;
    },
  },
  methods: {
    toggleSection(section) {
      const index = this.sections.indexOf(section);
      if (index >= 0) this.sections.splice(index, 1);
      if (index < 0) this.sections.push(section);
    },

    sectionIncluded(section) {
      return this.sections.indexOf(section) >= 0;
    },

    pdf() {
      if (
        this.value &&
        this.value.length === 1 &&
        this.opportunity &&
        this.opportunity.id
      ) {
        this.newTab();
      } else if (this.value && this.value.length > 0) this.createBundle();
    },

    createBundle() {
      this.$store
        .dispatch("client/documentBundles/create", {
          sections: this.sections,
          opportunityApplicationIds: this.value,
        })
        .finally(() => (this.exporting = false));
    },

    async newTab() {
      await this.handleGeneratedDocumentRequest(
        this.$http.get(
          `${this.$root.$api}/client/opportunities/${this.opportunity.id}/applications/${this.value[0]}.pdf`,
          {
            params: {
              auth_token: this.$auth.getToken(),
              sections: this.sections,
            },
            responseType: "blob",
          }
        ),
        {
          openInline: true,
          pendingMessage:
            "Your application document has been requested. You will receive an email with a download link.",
          errorMessage: `PDF generation error, please let us know: Application ID ${this.value[0]}.`,
        }
      );
      this.exporting = false;
    },
  },
};
</script>
